import React from 'react';
import PropTypes from 'prop-types';

/**
 * Custom Alert component that doesn't rely on react-bootstrap's Transition
 * This fixes the issue with the error alert
 */
const Alert = ({ variant, className, children, role = "alert" }) => {
  // Define base classes based on variant
  const baseClasses = {
    danger: "border-l-4 border-red-500 bg-red-50 text-red-700",
    success: "border-l-4 border-green-500 bg-green-50 text-green-700",
    warning: "border-l-4 border-yellow-500 bg-yellow-50 text-yellow-700",
    info: "border-l-4 border-blue-500 bg-blue-50 text-blue-700"};

  // Extract the base class for the current variant
  const baseClass = baseClasses[variant] || '';
  
  // Process className to remove any duplicate classes that are already in baseClass
  const processedClassName = className ? 
    className
      .join(' ') : 
    '';

  // Combine base classes with any additional classes (after removing duplicates)
  const alertClasses = `${baseClass} ${processedClassName} p-3 text-sm`.trim();

  return (
    <div role={role} className={alertClasses}>
      {children}
    </div>
  );
};

Alert.propTypes = {
  variant: PropTypes.oneOf(['danger', 'success', 'warning', 'info']).isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  role: PropTypes.string
};

export default Alert;
